/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} So_Status_Document_IssuedInputs */

const en_so_status_document_issued = /** @type {(inputs: So_Status_Document_IssuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document issued`)
};

/**
* | output |
* | --- |
* | "Document issued" |
*
* @param {So_Status_Document_IssuedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const so_status_document_issued = /** @type {((inputs?: So_Status_Document_IssuedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<So_Status_Document_IssuedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_so_status_document_issued(inputs)
});